/**
 * Section Component
 *
 * Collapsible section with header and content.
 */

import React from 'react';

export interface SectionProps {
  title: string;
  children: React.ReactNode;
  collapsible?: boolean;
  isExpanded?: boolean;
  onToggle?: () => void;
  className?: string;
}

export const Section: React.FC<SectionProps> = ({
  title,
  children,
  collapsible = false,
  isExpanded = true,
  onToggle,
  className = '',
}) => {
  return (
    <div className={`mb-7 ${className}`}>
      <div
        className={`
          font-bold text-xs uppercase tracking-wider text-indigo-600
          border-b-2 border-indigo-600 pb-1 mb-3
          ${collapsible ? 'cursor-pointer hover:text-indigo-700' : ''}
        `}
        onClick={collapsible ? onToggle : undefined}
      >
        {collapsible && (
          <span className="mr-2">{isExpanded ? '▼' : '▶'}</span>
        )}
        {title}
      </div>

      {isExpanded && <div>{children}</div>}
    </div>
  );
};
